import { graphql } from '~publish/graphql'
import { useTypedMutation } from '~publish/hooks/useTypedMutation'

const MoveFeed = graphql(/* GraphQL */ `
  mutation MoveFeed($input: MoveFeedInput!) {
    moveFeed(input: $input) {
      __typename
      ... on FeedMoveUpdatesResponse {
        updatedFeeds {
          id
          name
          collection {
            id
            name
          }
        }
        updatedFeedCollections {
          id
          name
          feeds {
            id
            name
          }
        }
      }
    }
  }
`)

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const useMoveFeed = () =>
  useTypedMutation(MoveFeed, (data) => data.moveFeed, {
    successTypename: 'FeedMoveUpdatesResponse',
  })
